type Props = {
	title: string;
};
export const SubTitle = (props: Props) => {
	return (
		<div
			className={
				"bg-suzuka2024naby text-white font-bold text-xl text-center px-4 py-1 w-fit h-fit mr-4 md:text-3xl md:px-6 md:py-2"
			}
		>
			<p className={"whitespace-nowrap"}>{props.title}</p>
		</div>
	);
};
